import { render, staticRenderFns } from "./TagShow.vue?vue&type=template&id=e4d28c62&scoped=true&"
import script from "./TagShow.vue?vue&type=script&lang=js&"
export * from "./TagShow.vue?vue&type=script&lang=js&"
import style0 from "./TagShow.vue?vue&type=style&index=0&id=e4d28c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d28c62",
  null
  
)

export default component.exports